import { useMemo } from 'react';

import { useGetContentCategories } from '../api';

export const useContentCategoryOptions = (pageId?: string | null) => {
  const { data } = useGetContentCategories({ pageId });

  const categories = useMemo(() => data?.categories ?? [], [data?.categories]);

  return useMemo(
    () => categories.map((category) => ({ value: category.name, label: category.name })),
    [categories]
  );
};
